import loadingGif from "@/assets/system/loading.gif";

export const LayoutLoading = () => (
  <div className="flex h-dvh w-full items-center justify-center">
    <img src={loadingGif} className="w-[200px]" />
  </div>
);
